import type React from 'react';
import { Path, Editor } from 'slate';
import areSamePoints from '@atlas/tool/box/slate/areSamePoints';
import deleteSelection from '@atlas/tool/box/slate/deleteSelection';
import deleteBlockPart from '@atlas/tool/box/slate/deleteBlockPart';

export default function handleSelectionDeletionKeyDownEvent(editor: Editor, event: React.KeyboardEvent): boolean {
    // TODO: @Stan if first block is HorizontalLine the Select All put both anchor and focus to the end
    if (event.key !== 'Backspace' && event.key !== 'Delete') return false;

    if (!editor.selection) return false;
    const { anchor, focus } = editor.selection;
    if (areSamePoints(anchor, focus)) return false;

    event.preventDefault();

    if (Path.equals(anchor.path.slice(0, -1), focus.path.slice(0, -1))) {
        deleteBlockPart(editor, editor.selection);
    } else {
        deleteSelection(editor, editor.selection);
    }

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('handleSelectionDeletionKeyDownEvent', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
